/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShockEventChartDataPoint
 */
export interface ShockEventChartDataPoint {
    /**
     * 
     * @type {Date}
     * @memberof ShockEventChartDataPoint
     */
    bucket: Date;
    /**
     * 
     * @type {number}
     * @memberof ShockEventChartDataPoint
     */
    severe: number;
    /**
     * 
     * @type {number}
     * @memberof ShockEventChartDataPoint
     */
    medium: number;
    /**
     * 
     * @type {number}
     * @memberof ShockEventChartDataPoint
     */
    light: number;
}

/**
 * Check if a given object implements the ShockEventChartDataPoint interface.
 */
export function instanceOfShockEventChartDataPoint(value: object): value is ShockEventChartDataPoint {
    if (!('bucket' in value) || value['bucket'] === undefined) return false;
    if (!('severe' in value) || value['severe'] === undefined) return false;
    if (!('medium' in value) || value['medium'] === undefined) return false;
    if (!('light' in value) || value['light'] === undefined) return false;
    return true;
}

export function ShockEventChartDataPointFromJSON(json: any): ShockEventChartDataPoint {
    return ShockEventChartDataPointFromJSONTyped(json, false);
}

export function ShockEventChartDataPointFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShockEventChartDataPoint {
    if (json == null) {
        return json;
    }
    return {
        
        'bucket': (new Date(json['bucket'])),
        'severe': json['severe'],
        'medium': json['medium'],
        'light': json['light'],
    };
}

export function ShockEventChartDataPointToJSON(json: any): ShockEventChartDataPoint {
    return ShockEventChartDataPointToJSONTyped(json, false);
}

export function ShockEventChartDataPointToJSONTyped(value?: ShockEventChartDataPoint | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'bucket': value['bucket'].toISOString(),
        'severe': value['severe'],
        'medium': value['medium'],
        'light': value['light'],
    };
}

